import {Construtor} from './construtor';

export class EmailOcorrencia implements Construtor<EmailOcorrencia> {
  public destinatario: string;
  public assunto: string;
  public conteudo: string;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof EmailOcorrencia) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  copyObject(emailOcorrencia: EmailOcorrencia): void {
    this.destinatario = emailOcorrencia.destinatario;
    this.assunto = emailOcorrencia.assunto;
    this.conteudo = emailOcorrencia.conteudo;
  }

  parseFromJson(emailOcorrencia: any): void {
    this.destinatario = emailOcorrencia.destinatario;
    this.assunto = emailOcorrencia.assunto;
    this.conteudo = emailOcorrencia.conteudo;
  }

  modeloCompleto(): boolean {
    return this.destinatario !== undefined && this.assunto !== undefined && this.conteudo !== undefined;
  }

  getNewInstance(object?: any): EmailOcorrencia {
    return new EmailOcorrencia(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/email-ocorrencia.ts